import React from 'react'
import PropTypes from 'prop-types'
import { Field, getIn } from 'formik'
import classNames from 'classnames'
import * as S from '../../Checkbox/styled'
import Error from '../Error'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons/faInfoCircle'

import { Help } from '@peracto/peracto-ui'

const Checkbox = ({
    name,
    label,
    groupLabel,
    help,
    defaultValue = null,
    onChange,
    actionPanel = false,
    tooltip,
    ...props
}) => {
    return (
        <Field name={name}>
            {({ field, form }) => {
                let error = getIn(form.errors, name)

                if (error) {
                    const errorFieldName = label ? label : 'This'
                    error = error.replace(field.name, errorFieldName)
                }

                const className = classNames('form-control', props.className)

                if (help) {
                    props['aria-describedby'] = `${name}Help`
                }

                if (typeof field.value == 'string') {
                    form.setFieldValue(field.name, field.value != 'false')
                }

                if (defaultValue !== null && typeof field.value === 'undefined') {
                    form.setFieldValue(field.name, !!defaultValue)
                }

                return (
                    <div
                        className={classNames('form-group', {
                            'has-error': error,
                            '!mb-0 !ml-4': actionPanel,
                            '!mb-2': !actionPanel,
                        })}
                    >
                        {groupLabel && <label className="!mb-0">{groupLabel}</label>}

                        <S.Checkbox
                            htmlFor={name}
                            data-testid={`label-${name.toLowerCase().replaceAll(' ', '-')}`}
                        >
                            <input
                                id={name}
                                type="checkbox"
                                checked={field.value}
                                onChange={e => {
                                    if (typeof onChange === 'function') {
                                        onChange(e)
                                    } else {
                                        form.setFieldValue(field.name, e.target.checked)
                                    }
                                }}
                                className={className}
                                data-value={field.value}
                                disabled={form.isSubmitting || props.disabled}
                            />

                            <span
                                className="checkbox"
                                data-testid={`checkbox-${name.toLowerCase().replaceAll(' ', '-')}`}
                            ></span>

                            {label}

                            {tooltip && (
                                <span
                                    data-tooltip={tooltip}
                                    className={classNames('!ml-2', {
                                        'tooltip-wrap': tooltip.length > 50,
                                    })}
                                >
                                    <FontAwesomeIcon icon={faInfoCircle} />
                                </span>
                            )}
                        </S.Checkbox>

                        {help && <Help className="!mb-0" id={`${name}Help`} help={help} />}

                        {error && <Error error={error} />}
                    </div>
                )
            }}
        </Field>
    )
}

Checkbox.displayName = 'Checkbox'

Checkbox.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    help: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    className: PropTypes.string,
}

export default Checkbox
